import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const ChartContainer = styled.div`
  ${({ theme }) => `
  .x-grid-line, .y-grid-line, .x-axis-bottom, .y-axis-left {
    stroke: ${theme.border.medium};
  }

  .x-tick, .y-tick {
    fill: ${theme.text.onSurface.subtle};
  }

  .x-tick {
    text-transform: lowercase;
  }

  @media screen and (min-width: ${cxTheme.breakpoints.desktop}px) {
    .x-efa-tick {
      display: block;
    }
  `}
`;
